import { Env } from "@zickko/shared";
import { connectStorageEmulator, getStorage } from "firebase/storage";
import { clientConfig } from "../config/clientConfig";
import { firebaseApp } from "./firebaseApp";

// Initialize Cloud Storage and get a reference to the service
export const firebaseStorage = getStorage(firebaseApp);

// emulator
if (clientConfig.env == Env.local) {
  connectStorageEmulator(firebaseStorage, "127.0.0.1", 9199);
}
